import React, { useState } from 'react';
import SearchGroupStyled from './SearchGroupStyled';
import { useTheme } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from '@material-ui/core';

const SearchGroup = React.forwardRef((props) => {
  const theme = useTheme();
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { name } = query;
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      name,
    },
  });
  const [titleValue, setTitleValue] = useState();
  //点击搜索
  const onSubmit = (data) => {
    const searchData = { ...data };
    handleSearch && handleSearch(searchData);
    console.log(data);
  };
  //点击重置
  const handleRestClick = () => {
    const resetData = {
      name: '',
    };
    setTitleValue('');
    reset(resetData);
    restClick && restClick(resetData);
  };
  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line" mb={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="name"
                    variant="standard"
                    label="活动名称"
                    value={rp.value ?? titleValue}
                    onChange={(e) => {
                      setValue('name', e.target.value);
                      setTitleValue(e.target.value);
                      return rp.value;
                    }}
                    placeholder="请输入活动名称"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('name', '');
                              setTitleValue('');
                            }}
                            edge="end"
                          >
                            {titleValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="name"
                control={control}
                defaultValue=""
              />
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_marketing_activity_miniprogram_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});
export default SearchGroup;
